module.exports = __webpack_public_path__ + "static/media/item-empty.4881a1e9.svg";